// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export const constants = {
    footer: {
        offsetTop: 52,
    },
    searchInput: {
        breakpoints: {
            lg: 1280,
        },
    },
    cartLine: {
        breakpoints: {
            md: 1200,
            xs: "xs",
        },
    },
    productList: {
        xSortAndFilter: {
            screen: "isTabletScreen",
            breakpoint: "md",
        },
    },
    productGridView: {
        desktop: {
            width: 308,
            height: 308,
        },
        tablet: {
            width: 230,
            height: 230,
        },
        mobile: {
            width: 280,
            height: 280,
        },
    },
};

export const SLIDES_PER_VIEW_POINTS = {
    xs: 0,
    sm: 1,
    md: 2,
    lg: 3,
};

export const FAMILY_OF_BRANDS_CAROUSEL_SLIDES_PER_SCREENSIZE = {
    mobile: 2,
    tablet: 3,
    desktop: 5.4,
};

export const BRAND_GALLERY_SLIDES_PER_SCREENSIZE = {
    mobile: 1.7,
    tablet: 4.1,
    desktop: 5.7,
};

export const FEATURED_CATEGORIES_CAROUSEL_SLIDES_PER_SCREENSIZE = {
    mobile: 2,
    tablet: 3,
    desktop: 5,
};

export const EMPTY_VALUE = "- -";
export const DivWrapper = `div[class^="Wrapper"]`;
export const ErrorApiDefaultMessage = "Please try again and contact support if you continue to have issues.";

export const XNGAGE_ELEMENTS = "Xngage" as any;

export const sharedDateTimeOptions: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

export const checkoutPages = [
    "CheckoutShippingPage",
    "CheckoutReviewAndSubmitPage",
    "OrderConfirmationPage",
    "RfqRequestQuotePage",
    "RfqConfirmationPage",
];

export const XngCustomGroup = "XNGAGE" as any;

export enum ShippingTerms {
    thirdParty = "05",
    collect = "02",
    PPDADD = "03",
}

export enum Carriers {
    willCall = "will call",
    ups = "ups",
    motorFreight = "motor freight",
}

export const SHIPPING_TERMS = {
    [Carriers.motorFreight]: {
        terms: [ShippingTerms.PPDADD, ShippingTerms.collect, ShippingTerms.thirdParty] as string[],
    },
};

export const RquiresMtrOrderStatus = ["C", "Ship-P", "Ship-C", "Invoice"];

export const AllProductPageContexts = ["AllProductsPage", "HomePage"];

export enum USER_ROLES {
    ADMIN = "Administrator",
    BUYER1 = "Buyer1",
    BUYER2 = "Buyer2",
    BUYER3 = "Buyer3",
    EMPLOYEE = "TPS_Employee",
}

export const ORDER_TYPES = [
    { value: "WEB", label: "WEB" },
    { value: "REG", label: "REG" },
    { value: "BACK", label: "BACK" },
    { value: "RMA", label: "RMA" },
];
